// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: submitsurvey.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "survey";

export interface SubmitSurveyRequest {
  caseId: string;
  rating: number;
  comment?: string | undefined;
}

export interface SubmitSurveyResponse {
  success: boolean;
  message: string;
}

function createBaseSubmitSurveyRequest(): SubmitSurveyRequest {
  return { caseId: "", rating: 0, comment: undefined };
}

export const SubmitSurveyRequest: MessageFns<SubmitSurveyRequest> = {
  encode(message: SubmitSurveyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    if (message.rating !== 0) {
      writer.uint32(16).int32(message.rating);
    }
    if (message.comment !== undefined) {
      writer.uint32(26).string(message.comment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitSurveyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitSurveyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.rating = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitSurveyRequest {
    return {
      caseId: isSet(object.caseId) ? globalThis.String(object.caseId) : "",
      rating: isSet(object.rating) ? globalThis.Number(object.rating) : 0,
      comment: isSet(object.comment) ? globalThis.String(object.comment) : undefined,
    };
  },

  toJSON(message: SubmitSurveyRequest): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    if (message.rating !== 0) {
      obj.rating = Math.round(message.rating);
    }
    if (message.comment !== undefined) {
      obj.comment = message.comment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitSurveyRequest>, I>>(base?: I): SubmitSurveyRequest {
    return SubmitSurveyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitSurveyRequest>, I>>(object: I): SubmitSurveyRequest {
    const message = createBaseSubmitSurveyRequest();
    message.caseId = object.caseId ?? "";
    message.rating = object.rating ?? 0;
    message.comment = object.comment ?? undefined;
    return message;
  },
};

function createBaseSubmitSurveyResponse(): SubmitSurveyResponse {
  return { success: false, message: "" };
}

export const SubmitSurveyResponse: MessageFns<SubmitSurveyResponse> = {
  encode(message: SubmitSurveyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitSurveyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitSurveyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitSurveyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: SubmitSurveyResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitSurveyResponse>, I>>(base?: I): SubmitSurveyResponse {
    return SubmitSurveyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitSurveyResponse>, I>>(object: I): SubmitSurveyResponse {
    const message = createBaseSubmitSurveyResponse();
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
